module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/coffee_459971.jpg";